// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"b7b65ee5","453":"6685e9bd"}[chunkId] + ".chunk.js";
};